import { AbstractControl } from '@angular/forms';

export interface HexColorValidator {
  validHexColor: boolean;
}

export function validateHexColor(control: AbstractControl): HexColorValidator | null {
  if (
    control.value === null ||
    control.value === undefined ||
    typeof control.value !== 'string' ||
    !/^#[0-9A-F]{6}$/i.test(control.value)
  ) {
    return { validHexColor: false };
  }
  return null;
}
